import React from "react";

const WrapperButtonDiv = props => {
  return <div className="input-group d-flex justify-content-center p-5"> {props.children}</div>;
}
export default WrapperButtonDiv;
